// extracted by mini-css-extract-plugin
export default {"button":"button-gradient_button__DKC4O","disabled":"button-gradient_disabled__Hf2of","text":"button-gradient_text__-IF4b"};